<template>
  <template v-if="titleForRow">
    <template v-if="column && column.list && column.list.length">
      <el-table-column v-bind="$attrs">
        <template v-slot:header>
          <div class="" :style="[getFont]" :title="column.showName">
            {{ column.name }}
          </div>
        </template>
        <template v-for="item in column.list" :key="item.id">
          <tableDetailCol v-bind="$attrs" :column="item" :lable="item.name" :prop="item.title" :width="isFixed ? '' : item.w" :min-width="isFixed ? item.percentageW : 170">
            <template v-slot:header="scope" v-if="$slots.header">
              <slot name="header" v-bind="{ ...scope, filedInfo: item }"></slot>
            </template>
            <template #default="scope" v-if="$slots.default">
              <slot v-bind="{ ...scope, filedInfo: item }"></slot>
            </template>
          </tableDetailCol>
        </template>
      </el-table-column>
    </template>
    <template v-else>
      <el-table-column v-bind="$attrs">
        <template v-slot:header="scope" v-if="$slots.header">
          <slot name="header" v-bind="scope"></slot>
        </template>
        <template #default="scope" v-if="$slots.default">
          <slot v-bind="scope"></slot>
        </template>
      </el-table-column>
    </template>
  </template>
  <template v-else>
    <template v-if="column && column.list && column.list.length && column.type !== 'new-rel-radio'">
      <el-table-column v-bind="$attrs">
        <template v-slot:header>
          <div class="" :style="[getFont]" :title="column.showName">
            {{ column.ctitle || column.name }}
          </div>
        </template>
        <template v-for="item in column.list" :key="item.title">
          <tableDetailCol :listTodoField="listTodoField" v-if="!item.name.includes('approving_id') && !item.isHide" @clearActiveCol="todoReset" :approvalId="approvalId" :activeCol="activeCol" @handleEdit="handleEdit" :label="item.name" :render-header="renderHeader" :key="item.title" :fatherName="listName(item)" :column="item">
            <template v-slot="scope">
              <div :style="[getAlign, { minHeight: '22px' }]" @dblclick="handleEdit(scope.row, item, listName(item), $event)" class="col" style="height: 100%;">
                <template v-if="item.customType === 'options'">
                  <template v-if="item.type === 'radio'">
                    <el-radio style="height: 22px;" @change="changeValue({ value: $event, row: scope.row, item })" :label="item.label" :value="scope.row[listName(item)]" :disabled="!Boolean(listTodoField[item.otherName])">
                      <span></span>
                    </el-radio>
                  </template>
                  <template v-else-if="item.type === 'checkbox'">
                    <el-checkbox style="height: 22px;" @change="changeValue({ value: $event, row: scope.row, item })" :value="scope.row[listName(item)]" :true-label="item.value" :false-label="''" :disabled="!Boolean(listTodoField[item.otherName])">
                      <span></span>
                    </el-checkbox>
                  </template>
                </template>
                <template v-else>
                  <template v-if="activeCol.title === listName(item) && activeCol.approvingId === scope.row.approvingId && listTodoField[item.title]">
                    <todoEdit ref="todoEditRef" :appendToBody="!!tableStyleField.isTodoDiagle" @change="todoChange" @reset="todoReset" :approvalId="approvalId" />
                  </template>
                  <template v-else>
                    <div :style="[getValueFont, getColor(item, scope)]" class="customization-clamp zdysy">
                      {{ scope.row[listName(item)] }}
                    </div>
                  </template>
                </template>
              </div>
            </template>
          </tableDetailCol>
        </template>
      </el-table-column>
    </template>
    <template v-else>
      <el-table-column v-bind="$attrs">
        <template v-slot:header="scope" v-if="$slots.header">
          <slot name="header" v-bind="{ ...scope , filedInfo: column }"></slot>
        </template>
        <template #default="scope" v-if="$slots.default">
          <slot v-bind="{ ...scope, filedInfo: column }"></slot>
        </template>
      </el-table-column>
    </template>
  </template>
</template>

<script>
import todoEdit from '@/components/schoolInstrument/component/mutual/component/form/todoEdit.vue'
import { getLabelColor } from '@/api/instrumentControl'
import { updateapprovingbyfeild } from "@/port/clientSide/oaExamineAudit";
import { h } from 'vue'
export default {
  // 组件名称
  name: 'tableDetailCol',
  // 组件参数 接收来自父组件的数据
  props: {
    column: {
      type: Object,
      default: () => ({})
    },
    tableDetailData: {
      type: Object,
      default: () => ({})
    },
    tableStyleField: {
      type: Object,
      default: () => ({})
    },
    fatherName: {
      type: String,
      default: ''
    },
    listTodoField: {
      type: Object,
      default: () => {}
    },
    activeCol: {
      type: Object,
      default: () => ({})
    },
    titleForRow: {
      type: Boolean,
      default: false
    },
    isFixed: {
      type: Boolean,
      default: false
    },
    approvalId:{
      type: [String, Number],
      default: ''
    },
  },
  // 局部注册的组件
  components: {
    todoEdit
  },
  // 组件状态值
  data () {
    return {}
  },
  // 计算属性
  computed: {
    correlation() {
      const obj = {}
      for (const key in this.listTodoField) {
        const value = this.listTodoField[key]
        if (value.associationVisible && value.associationVisible.associationswitch) {
          for (const item of value.associationVisible.Visiblel) {
            for (const ckey in item.value) {
              if (item.value[ckey]) {
                const title = ckey.split('_')[0]
                obj[title] = {
                  value: item.key,
                  title: value.title,
                  name: value.name,
                  otherName: key,
                }
              }
            }
          }
        }
      }
      return obj
    },
    getAlign () {
      let obj = {}
      const titleConfig = this.tableDetailData.titleConfig
      if (titleConfig) {
        obj = {
          display: 'flex',
          alignItems: 'center',
          justifyContent: titleConfig && titleConfig.textAlign ? titleConfig.textAlign : 'left'
        }
      }
      return obj
    },
    // 查询文字设置样式
    getFont () {
      if (!this.tableDetailData.titleConfig) return {}
      const obj = JSON.parse(JSON.stringify(this.tableDetailData.titleConfig))
      return obj
    },
    getValueFont () {
      if (!this.tableDetailData.valueConfig) return {}
      const obj = JSON.parse(JSON.stringify(this.tableDetailData.valueConfig))
      return obj
    },
  },
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    async changeValue(opt){
      const { row, item } = opt
      const rowLabel = this.listName(item)
      const approvingId = row[rowLabel.substring(0, rowLabel.lastIndexOf(".")) + ".approving_id"]
      if (!approvingId) {
        this.$message.error('找不到数据id')
        return
      }
      row[rowLabel] = item.value
      const param = {
        approvalId: this.approvalId,
        approvingId,
        feild: `${item.newTitle}_${item.type}`,
        value: item.value
      }
      await this.updateAppField(param)
    },
    getSel(item, key){
      if (typeof item === 'object') {
        return item[key]
      } else {
        return item
      }
    },
    async todoChange (val = {}) {
      const { row, column, value, pivotConfig } = val
      const rowLabel = pivotConfig.rowLabel
      const approvingId = row[rowLabel.substring(0, rowLabel.lastIndexOf(".")) + ".approving_id"]
      if (approvingId) {
        const param = {
          approvalId: this.approvalId,
          approvingId,
          feild: `${column.title}_${column.type}`,
          value
        }
        await this.updateAppField(param)
        this.$emit('clearActiveCol')
      } else {
        this.$message.error('id不存在')
        this.$emit('clearActiveCol')
      }
    },
    todoReset () {
      this.$emit('clearActiveCol')
    },
    async updateAppField(obj) {
      const res = await updateapprovingbyfeild(obj)
      if (res.code === 0) {
        this.$message.success('修改成功')
        return true
      } else {
        this.$message.error(res.msg)
      }
    },
    handleEdit(row, item, fatherName, e) {
      if (item.customType === 'options') return
      const column = this.listTodoField[item.title]
      const correlation = this.correlation[column.title]
      if (correlation) {
        const otherName = correlation.otherName
        const filed = this.column.list.find(item => item.otherName === otherName)
        if (filed) {
          const labelName = this.listName(filed)
          const value = row[labelName]
          if (value !== correlation.value) {
            this.$message.error('请选择关联数据')
            return
          }
        }
      }
      let rect = {}
      let cell = e.target
      let flag = true
      while (flag) {
        cell = cell.parentNode
        if (cell.classList.contains('el-table__cell')) {
          flag = false
        }
        if (cell === null) {
          cell = e.target
          flag = false
        }
      }
      if (cell) {
        rect = cell.getBoundingClientRect()
      }
      const pivotConfig = {
        value: row[this.listName(item)],
        rowLabel: this.listName(item),
        title: column.title,
      }
      this.$emit('handleEdit', row, item, fatherName)
      this.$nextTick(() => {
        this.$refs.todoEditRef[0].open({ row, column, rect, pivotConfig })
      })
    },
    renderHeader({ column }) {
      const textLen = column.label.trim()
      let canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      const textWidth = context.measureText(textLen).width + 50;
      canvas = null
      column.width = textWidth
      // column.width = 180
      return h('div', { style: this.getAlign,}, [h('div', { class: 'ellipsis', style: this.getFont }, [column.label])])
    },
    // - 表格名称格式修改
    formNameChange (val) {
      let value = val.split('.')
      value = value.join('')
      return value
    },
    listName (item) {
      let str = this.fatherName
      const fatherType = this.column.fatherType
      const key = item.customType === 'options' ? 'otherName' : 'name'
      if (!str && fatherType) {
        str = fatherType.split('_')[0] + '.' + this.column.name + '.' + item[key]
      } else {
        str = this.fatherName + '.' + item[key]
      }
      return str
    },
    getColor (item, scope) {
      const property = scope.column.property
      const val = scope.row[property]

      return this.getColorNoe(item, val)
    },
    getColorNoe (item, val) {
      if (item.isColor && item.options && (val || val === 0)) {
        const obs = getLabelColor(item, val)
        return obs
      }
      return {}
    }
  }
}
</script>

<style scoped lang="scss">
.customization-clamp {
  overflow: hidden;
  -webkit-box-orient: vertical;
  white-space: normal;
  transition: 0.3s;
}

.ellipsis {
  white-space: nowrap;
  overflow: visible;
  text-overflow: initial;
}
</style>
